import type { Bus_Events } from './events';

export const bus = {
    on<K extends keyof Bus_Events>( type: K, handler: ( ...args: Bus_Events[K] ) => void ): void {
        document.addEventListener(
            type,
            ( e: Event ) => {
                console.log( 'on', type )
                const detail: Bus_Events[K] = ( e as CustomEvent<Bus_Events[K]> ).detail;
                handler( ...detail )
            }
        )
    },

    emit<K extends keyof Bus_Events>( type: K, ...args: Bus_Events[K] ): void {
        console.log( 'emit', type )
        document.dispatchEvent( new CustomEvent( type, { detail: args } ) )
    },
};
